<div class="modal hide fade">
	<div class="modal-header clearfix">
		<button class="close" data-dismiss="modal">X</button>
	</div>
	<div class="modal-body">
		<%= content %>
	</div>
</div>
